/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingInfoField } from './BookingInfoField';
import {
    BookingInfoFieldFromJSON,
    BookingInfoFieldFromJSONTyped,
    BookingInfoFieldToJSON,
    BookingInfoFieldToJSONTyped,
} from './BookingInfoField';

/**
 * 
 * @export
 * @interface GetBookingInfoResponse
 */
export interface GetBookingInfoResponse {
    /**
     * 
     * @type {Array<BookingInfoField>}
     * @memberof GetBookingInfoResponse
     */
    fields: Array<BookingInfoField>;
}

/**
 * Check if a given object implements the GetBookingInfoResponse interface.
 */
export function instanceOfGetBookingInfoResponse(value: object): value is GetBookingInfoResponse {
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function GetBookingInfoResponseFromJSON(json: any): GetBookingInfoResponse {
    return GetBookingInfoResponseFromJSONTyped(json, false);
}

export function GetBookingInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBookingInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fields': ((json['fields'] as Array<any>).map(BookingInfoFieldFromJSON)),
    };
}

export function GetBookingInfoResponseToJSON(json: any): GetBookingInfoResponse {
    return GetBookingInfoResponseToJSONTyped(json, false);
}

export function GetBookingInfoResponseToJSONTyped(value?: GetBookingInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fields': ((value['fields'] as Array<any>).map(BookingInfoFieldToJSON)),
    };
}

